import styled, { css } from 'styled-components'

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  // position: relative;
`